import { ContactDetail } from '@shared/types/ContactDetail';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

export const PhoneNumberHelper = () => {
  const substringPhoneNumbers = (number: string) => `${format(number).substring(0, 10)}...`;

  const phoneUtil = PhoneNumberUtil.getInstance();
  const format = (phone: string) => {
    try {
      return phoneUtil.format(phoneUtil.parse(phone), PhoneNumberFormat.INTERNATIONAL);
    } catch {
      return phone;
    }
  };

  const sidebarPhoneNumber = (phonenumber: string) => format(phonenumber);

  const fullPhoneNumber = (contactDetails: ContactDetail[], id: number) =>
    sidebarPhoneNumber(contactDetails.filter((contact) => contact.id === id)[0].phoneNumber);

  return {
    format,
    sidebarPhoneNumber,
    substringPhoneNumbers,
    fullPhoneNumber,
  };
};
